import { t } from '@lingui/core/macro';
import {
    CenteredLayout,
    Flexbox,
    NonIdealState,
    SecondaryButton,
    TertiaryButton,
    TriangleAlertFilledIcon,
} from '@luminovo/design-system';
import { LogOutIcon, RefreshCwIcon } from 'lucide-react';

/** `onLogOut` adds a Log out button, for a route's error page: a refresh can end on the same error. */
export const SadBox = ({ onLogOut }: { onLogOut?: () => void }) => (
    <CenteredLayout>
        <NonIdealState
            variant="error"
            icon={<TriangleAlertFilledIcon />}
            title={t`Unexpected error`}
            description={t`Sorry, it looks like something went wrong. Try refreshing the page. If this problem persists, please contact our support team.`}
            action={withLogOut(
                <SecondaryButton
                    size="small"
                    startIcon={<RefreshCwIcon />}
                    onClick={() => window.location.replace(window.location.href)}
                >
                    {t`Refresh`}
                </SecondaryButton>,
                onLogOut,
            )}
        />
    </CenteredLayout>
);

/** `action` with a Log out button next to it, or below it where a translation makes the two too wide for the box. */
export function withLogOut(action: JSX.Element, onLogOut: (() => void) | undefined): JSX.Element {
    if (!onLogOut) {
        return action;
    }
    return (
        <Flexbox gap="8px" sx={{ flexWrap: 'wrap', justifyContent: 'center' }}>
            {action}
            <TertiaryButton size="small" onClick={onLogOut} startIcon={<LogOutIcon />}>
                {t`Log out`}
            </TertiaryButton>
        </Flexbox>
    );
}
